import React, { useRef, useEffect } from 'react';
import { styled } from '@mui/material/styles';

const StyledTextarea = styled('textarea')(({ theme }) => ({
  width: '97.5%',
  fontSize: theme.typography.body1.fontSize,
  fontFamily: theme.typography.fontFamily,
  padding: theme.spacing(1.5),
  borderRadius: theme.shape.borderRadius,
  border: `1px solid ${theme.palette.grey[400]}`,
  resize: 'vertical', // allows user manual resize after auto-sizing
  overflow: 'hidden',
  minHeight: '80px',
  maxHeight: '1000px', // auto-expand limit
}));

export default function AutoExpandableResizableTextarea(props) {
  const textareaRef = useRef(null);

  useEffect(() => {
    const el = textareaRef.current;
    if (el) {
      el.style.height = 'auto'; // reset
      el.style.height = `${Math.min(el.scrollHeight, 1000)}px`; // max 200px auto height
    }
  }, [props.value]);

  return (
    <StyledTextarea
      ref={textareaRef}
      value={props.value}
      onChange={props.onChange}
      placeholder={props.placeholder}
      label={props.label}
      required={props.required}
    />
  );
}
